"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var LoadingLogo = function LoadingLogo(_ref) {
  var size = _ref.size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#fff' : _ref$color;
  var iconSize = size === 'original' ? 'width="30" height="52"' : 'width="100%"';
  var title = 'Loading Logo Icon';
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ").concat(iconSize, " viewBox=\"0 0 29.8 52.4\">\n      <title>").concat(title, "</title>\n      <path\n        d=\"M0,27.9c.5-.8,1-.9,1.9-.6,4.5,1.7,21.8,8,25.9,9.4a2.67,2.67,0,0,1,1.9,2.7V50.6a2,2,0,0,1-.4,1.3c0,.4-.1.4-.4.5h-.8C26,51.5,8.9,45.2,2.5,43A3.89,3.89,0,0,1,0,40.8Z\"\n        fill=").concat(color, "\n      />\n      <path\n        d=\"M29.8,24.9a2.67,2.67,0,0,0-1.9-2.7c-2.2-.8-19.5-7.1-26-9.4-1-.4-1.3-.3-1.9.5v9.9a3.76,3.76,0,0,0,2.4,2.2c2.3.8,19.2,7,25.5,9.3,1.1.4,1.9-.1,1.9-1.3Z\"\n        fill=").concat(color, "\n      />\n      <path\n        d=\"M27.8,9.6C20.6,7,3.2.6,1.7,0H.9A1.06,1.06,0,0,0,0,.9V8.5a3.7,3.7,0,0,0,2.4,2c4.3,1.5,21.3,7.8,25.5,9.3,1.1.4,1.8-.1,1.8-1.3V12.4A2.75,2.75,0,0,0,27.8,9.6Z\"\n        fill=").concat(color, "\n      />\n    </svg>\n  ");
};

var _default = LoadingLogo;
exports["default"] = _default;